import { useEffect } from "react";
import Toast from "../../base/components/Toast";
import {
   PaymentIntentStatus,
   PAYMENT_MESSAGES,
   notifyNonSuccessStatus
} from "./paymentStatus";

/**
 * Resolves a 3D Secure full-page redirect.
 *
 * Some issuers run 3DS as a redirect rather than the in-app modal. Stripe sends
 * the user back with `payment_intent_client_secret` in the URL; we retrieve the
 * intent, toast the outcome and strip the params so a refresh can't re-trigger
 * it. On success we call `onSuccess` to refresh the page data.
 *
 * The webhook grants funds regardless, so a client-side retrieval failure is
 * swallowed rather than surfaced as a false error.
 */
export function use3dsRedirectResult({ stripePromise, onSuccess }) {
   useEffect(() => {
      const params = new URLSearchParams(window.location.search);
      const clientSecret = params.get("payment_intent_client_secret");
      if (!clientSecret) return;

      stripePromise
         .then((stripe) => stripe?.retrievePaymentIntent(clientSecret))
         .then((result) => {
            const status = result?.paymentIntent?.status;
            if (status === PaymentIntentStatus.SUCCEEDED) {
               Toast.success(PAYMENT_MESSAGES.success);
               onSuccess?.();
            } else {
               notifyNonSuccessStatus(status);
            }
         })
         .catch(() => {
            // Couldn't confirm client-side; the webhook still grants funds.
         })
         .finally(() => {
            window.history.replaceState({}, "", window.location.pathname);
         });
   }, [stripePromise, onSuccess]);
}
